"use strict";

console.log("If you found this message, have a sweet day !");

//audio
localStorage.clear();

let audio = document.querySelector(".audio");
let audioButton = document.querySelector(".playpause");
audioButton.addEventListener("click", playOrPause);
let audioSongs = document.querySelectorAll(".yvi-list__button, .hannah-list__button");

for (const audioSong of audioSongs) {
    let songClass = audioSong.classList.value;
    songClass = songClass.replace('yvi-list__button', '').trim();
    songClass = songClass.replace('hannah-list__button', '').trim();

    audioSong.addEventListener("click", () => {
        document.body.setAttribute("data-audio", true);
        audioButton.classList.remove("pause");
        audioButton.classList.add("play");
        for (const audioSong of audioSongs) {
            audioSong.classList.remove("playing");   
        }
        audioSong.classList.add("playing");
    });
    
    if (songClass == "yvi-list__button-1"){
        audioSong.addEventListener("click", () => {
            audio.src = "assets/audios/yvi-1-rachmaninoff-vocalise.mp3";
        });
    }
    else if (songClass == "yvi-list__button-2"){
        audioSong.addEventListener("click", () => {
            audio.src = "assets/audios/yvi-2-animal-crossing-2am.mp3";
        });
    }
    else if (songClass == "yvi-list__button-3"){
        audioSong.addEventListener("click", () => {
            audio.src = "assets/audios/yvi-3-undertale-shop.mp3";
        });
    }
    else if (songClass == "hannah-list__button-1"){
        audioSong.addEventListener("click", () => {
            audio.src = "assets/audios/hannah-1-shirayuki.mp3";
        });
    }
    else if (songClass == "hannah-list__button-2"){
        audioSong.addEventListener("click", () => {
            audio.src = "assets/audios/hannah-2-pokemon-emotion.mp3";
        });
    }
    else if (songClass == "hannah-list__button-3"){
        audioSong.addEventListener("click", () => {
            audio.src = "assets/audios/hannah-3-fantastic-beasts.mp3";
        });
    }
    else if (songClass == "hannah-list__button-4"){
        audioSong.addEventListener("click", () => {
            audio.src = "assets/audios/hannah-4-pride-and-prejudice.mp3";
        });
    }
    else if (songClass == "hannah-list__button-5"){
        audioSong.addEventListener("click", () => {
            audio.src = "assets/audios/hannah-5-tarzan-meets-jane.mp3";
        });
    }
    else if (songClass == "hannah-list__button-6"){
        audioSong.addEventListener("click", () => {
            audio.src = "assets/audios/hannah-6-la-vita-e-bella.mp3";
        });
    }
}

function playOrPause(){
    if(document.body.hasAttribute("data-audio")){
        document.body.removeAttribute("data-audio");
		audioButton.classList.remove("play");
        audioButton.classList.add("pause");
        audio.pause();
    }else{
        document.body.setAttribute("data-audio", true);
		audioButton.classList.remove("pause");
        audioButton.classList.add("play");
        audio.play();
    }
}